import {
  CreateIncidentMessageDto,
  IncidentMessage,
  ResponseType,
  UpdateIncidentMessageDto,
} from '../types';
import { api } from './api';

export const getIncidentMessages = async () => {
  const { data } = await api.get<ResponseType<IncidentMessage[]>>(
    '/v1/vt-incidents/all'
  );
  return data;
};

export const deleteIncidentMessage = async (id: number) => {
  const res = await api.delete<ResponseType<null>>(`/v1/vt-incidents/${id}`);
  return res;
};

export const createIncidentMessage = async (data: CreateIncidentMessageDto) => {
  const res = await api.post<ResponseType<IncidentMessage>>(
    `/v1/vt-incidents`,
    data
  );
  return res;
};

export const updateIncidentMessage = async (
  id: number,
  data: UpdateIncidentMessageDto
) => {
  const res = await api.patch<ResponseType<IncidentMessage>>(
    `/v1/vt-incidents/${id}`,
    data
  );
  return res;
};
